import React from 'react';
import styled from 'styled-components';

const IconContainer = styled.div`
  margin: 0 auto;
  font-size: 80px;
  color: ${props => props.theme.colors.red_event};
  padding-bottom: 24px;
`;

export default IconContainer;
